import { CompanyRoles, ROLE_PROMOTER, ROLE_TEAM_LEADER } from '@domain/company';

export const filterByRole = ({ role, isHidden }: { role?: CompanyRoles; isHidden: boolean }): boolean => {
  if (role !== ROLE_TEAM_LEADER && role !== ROLE_PROMOTER) return true;
  return !isHidden;
};
